import { IModuleProps } from '../../core/utils/modules.tsx';

import routes from './routes.tsx';

export default {
    name: 'order_confirmations',
    routes,
} as IModuleProps;
